import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";

import { apolloClient } from "@lib/apollo";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>,
);
